module.exports = __webpack_public_path__ + "static/media/logo.ac8bce90.png";